module.exports = __webpack_public_path__ + "static/media/logoVersarSVG.6788dfbc.svg";